export { Schema as JobApplySchema } from "./jobApply.schema";
